<template>
    <div>
        <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>

        <NavBar></NavBar>
        <div class="container">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12">
                                    <vue-editor 
                                        id="editor" 
                                        :editor-toolbar="customToolbar" 
                                        :useCustomImageHandler="true" 
                                        @image-added="handleImageAdded" 
                                        @image-removed="handleImageRemoved"
                                        v-model="description" 
                                        :placeholder="'ระบุรายละเอียด...'
                                    "></vue-editor>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer p-2">
                            <button v-if="description!=''" type="button" class="btn btn-success float-right" @click="validateThanks">บันทึก</button>
                            <button v-else type="button" class="btn btn-success float-right" disabled>บันทึก</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';

import NavBar from '@/components/NavBar';

import { VueEditor, Quill } from "vue2-editor";
const BlockEmbed = Quill.import("blots/block/embed");
class ImageBlot extends BlockEmbed {
    static create(value) {
        const node = super.create();
        node.setAttribute("src", value.url);
        node.setAttribute("id", value.id);
        node.setAttribute("name", value.name);
        node.setAttribute("class", value.class);
        return node;
    }
    static value(node) {
        return {
            url: node.getAttribute("src"),
            id: node.getAttribute("id"),
            name: node.getAttribute("name"),
            class: node.getAttribute("class"),
        };
    }
}
ImageBlot.blotName = "image";
ImageBlot.tagName = "img";
Quill.register(ImageBlot);

export default {
    components:{
        NavBar,
        VueEditor
    },

    data(){
        return {
            user: null,
            show: false,
            validated: false,

            description: null,
            encodeDescription: null,
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                ["code-block"],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                ["image"], // "link", "image", "video"
                ["clean"] // remove formatting button
            ],
            formDes: new FormData(),
            fileDes: [],
            listFileDesRemove: [],
        }
    },

    created(){
        this.user = this.$store.state.user;
        this.getThanksActive();
    },

    methods:{
        handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            var blobUrl = URL.createObjectURL(file);

            var subBlobUrl = blobUrl.split('/');
            var codeFileName = subBlobUrl[3]; // subBlobUrl[3] => generateCode,

            var fileType = file.type.split('/');
            var fileName = codeFileName+'.'+fileType[1]; //  fileType[1] => type file
            var urlImg = Api.pathThanks(fileName);
            var encodeUrl = urlImg.split(process.env.VUE_APP_API).join("urlxxx");

            // var res = Array.from(this.formDes.entries());
            this.formDes.append("image["+codeFileName+"]", file, fileName);

            // d-block w-100 h-100
            Editor.insertEmbed(cursorLocation, "image", { id: codeFileName, url: blobUrl, name: fileName, class: "rounded mx-auto d-block" });
            resetUploader();

            this.fileDes.push({ id: codeFileName, blobUrl: blobUrl, encodeUrl: encodeUrl });
        },

        handleImageRemoved(file, Editor, cursorLocation) {
            var id = file.id;
            this.formDes.delete("image["+id+"]");
            this.fileDes = this.fileDes.filter((obj) => obj.id !== id );

            this.listFileDesRemove.push(file.name);
        },

        getThanksActive(){
            this.show = true;
            Api.getThanksActive().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.description = data.result.description.split("urlxxx").join(process.env.VUE_APP_API);
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        validateThanks(){
            if(this.description.trim()!=''){
                this.saveThanks();
            }
        },

        saveThanks(){
            this.show = true;

            var description = this.description.split(process.env.VUE_APP_API).join("urlxxx");
            this.encodeDescription = description;

            var res = Array.from(this.formDes.entries());
            if(res.length!=0){
                this.fileDes.forEach((item,index) => {
                    this.encodeDescription = this.encodeDescription.replace(item.blobUrl, item.encodeUrl);
                });
            }else{
                this.formDes.append("image[0]", "");
            }

            var data = {
                description: this.encodeDescription,
            };

            var token = this.user.token;
            var myJSON = JSON.stringify(data);
            this.formDes.append('data', myJSON);

            Api.saveThanks(token,this.formDes).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },
    }
}
</script>

<style scoped>
    #create-form {
        border: 1px solid rgba(0, 0, 0, 0.125);
    }

    /* .ql-snow .ql-toolbar button svg, .quillWrapper .ql-snow.ql-toolbar button svg {
        width: 20px !important;
        height: 18px !important;
        margin-left: -2px !important;
    } */
</style>